/**
 * Logs are on for `react-scripts start` (NODE_ENV !== 'production') and for any build
 * whose env file sets REACT_APP_ENABLE_LOG=true (dev / test), off for staging & production.
 */
const DEV_MODE_ENABLED =
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_ENABLE_LOG === 'true'

export function logDebug(...args: unknown[]) {
  if (!DEV_MODE_ENABLED) return
  console.debug.apply(null, [`[${new Date().toISOString()}, DEB]`, ...args])
}

export function logInfo(...args: unknown[]) {
  if (!DEV_MODE_ENABLED) return
  console.log.apply(null, [`[${new Date().toISOString()}, INF]`, ...args])
}

export function logWarn(...args: unknown[]) {
  if (!DEV_MODE_ENABLED) return
  console.warn.apply(null, [`[${new Date().toISOString()}, WRN]`, ...args])
}

export function logError(...args: unknown[]) {
  if (!DEV_MODE_ENABLED) return
  console.error.apply(null, [`[${new Date().toISOString()}, ERR]`, ...args])
}

export function logRender(...args: unknown[]) {
  if (!DEV_MODE_ENABLED) return
  console.log.apply(null, [`[${new Date().toISOString()}, REN]`, ...args])
}
